module.exports = __webpack_public_path__ + "img/carWashCode_02.5655bb15.jpg";